import { ISsoClaims } from '../models/Login/ISsoClaims';
import { ISsoProfile } from '../models/Login/ISsoProfile';

function loginServiceMock() {
  function login(): any {
    return new Promise((resolve, reject) => {
      resolve({
        access_token: '',
      });
      throw new Error('Mock exception!');
    });
  }

  function getSsoClaims(): ISsoClaims {
    const ssoProfile: ISsoProfile = {
      sub: 'glenn.hickman@shrm.org',
      MembershipSubType: 'Professional',
      MembershipEndDate: '2023-06-30T00:00:00+00:00',
      CobaltId: null,
      LabelName: ' Glenn Hickman Mock',
      dn: 'uid=glenn.hickman@shrm.org, samaccountname=glenn.hickman@shrm.org, dc=shrm.org',
      withinGracePeriod: false,
      HRPSId: 1107624,
      Segment: 'Unknown',
      SSOId: 1364174,
      userIdSystem: 'email',
      josso_user_dn:
        'uid=glenn.hickman@shrm.org, samaccountname=glenn.hickman@shrm.org, dc=shrm.org',
      auth_time: 1644439306,
      company: 'Society for Human Resource Management (SHRM)',
      membershipActive: true,
      HRPSMemEndDate: null,
      HRPSMemType: null,
      email: 'glenn.hickman@shrm.org',
      QualificationJSON: null,
      SSOUUID: 'E3D22DA6-FAE2-E511-80DB-00505688482B',
      FirstName: 'Glenn',
      MembershipParentName: 'Society for Human Resource Management (SHRM)',
      MembershipType: 'Enterprise',
      groups: ['role1'],
      PrimaryEmail: 'Glenn.Hickman@shrm.org',
      NickName: null,
      HRPSSubscription: false,
      ClassCode: ' ',
      SHRMId: null,
      Cohort: "{'specialization':null,'cohort':'CHRO'}",
      LastName: 'Hickman',
      LockoutEndDate: null,
      HRPSMemActive: false,
      MembershipParentId: '972133',
    };

    const ssoClaims: ISsoClaims = {
      id_token: '',
      session_state: '',
      scope: 'openid',
      profile: ssoProfile,
    };

    return ssoClaims;
  }

  return {
    login,
    getSsoClaims,
  };
}

export default loginServiceMock;
